<template>
  <div ref="filterGroup" class="filter-group">
    <el-row type="flex" align="middle" justify="space-between">
      <el-row ref="filterItems" class="filterItems" type="flex" v-gutter="8">
        <slot></slot>
        <gj-popover
            v-if="advancedFiltering"
            width="300"
            v-model="visiblePopover">
            <div slot="reference" class="advancedFiltering">
              <gj-icon iconfont="icongaojishanxuan" class="gj-help--icon"></gj-icon>
            </div>
            <div class="advancedFiltering-conent" v-if="visiblePopover">
              <div class="advancedFiltering-cell" v-for="item in screenOptons" :key="item.id">
                <span class="text">{{ item.text }}</span>
                <gj-select width="63px" :clearable="false" :filterable="false" v-model="item.exp" :options="expOptions" placeholder=""></gj-select>
                <gj-input class="item-input chunk-input-item" :clearable="false" v-model="item.value" :maxlength="item.maxlength || '12'" v-number.price>
                  <template #append v-if="item.suffix">{{ item.suffix }}</template>
                </gj-input>
              </div>
              <div class="advancedFiltering-footer">
                <gj-button plain @click="cancel">取消</gj-button>
                <gj-button type="primary" @click="determine">确定</gj-button>
              </div>
            </div>
        </gj-popover>

        <transition name="query">
          <gj-button
              v-if="query"
              class="query-button"
              :type="queryButtonType"
              style="height: 32px;"
              :loading="queryLoading"
              @click="handleQuery">
            查询
          </gj-button>
        </transition>

        <gj-button
            v-if="reset"
            style="height: 32px;"
            @click="resetFn">
          重置
        </gj-button>
        <gj-button
            v-if="showAdvancedFilterBtn"
            type="text"
            @click="showAdvancedFilterGroup = !showAdvancedFilterGroup">
          <template v-if="showAdvancedFilterGroup">
            <span>收起</span>
            <i class="el-icon-arrow-up icon-down"></i>
          </template>
          <template v-else>
            <span>高级查询</span>
            <i class="el-icon-arrow-down icon-down"></i>
          </template>
        </gj-button>
      </el-row>
      <div ref="filterRight"
           v-gutter="8"
           class="right-button-group">
        <slot name="right"></slot>
      </div>
    </el-row>
    <div class="extend-search" v-if="advancedFiltering && extendSearch && extendSearch.length != 0">
      <div v-for="(item, index) in extendSearch" :key="index" class="extend-search-cell">
        {{ item.name }}
        {{ getExp(item.exp) }}
        {{ item.value }}{{ item.suffix }}
        <i class="el-icon-close" @click="extendSearchClear(index, item)"></i>
      </div>
      <span class="clear-all" @click="extendSearchClearAll(true)">清空全部</span>
    </div>

    <el-row v-show="showSecondRow"
            ref="secondGroup"
            v-gutter="8"
            type="flex"
            class="filter-group__advanced secondGroup">
      <slot name="secondRow"></slot>
    </el-row>
    <el-row v-show="showAdvancedFilterBtn && showAdvancedFilterGroup"
            ref="filterAdvanceGroup"
            v-gutter="8"
            type="flex"
            class="filter-group__advanced">
      <slot name="advancedFilter"></slot>
    </el-row>
  </div>
</template>

<script>
  import emitter from '@/minxins/emitter'
  export default {
    name: "app-filter-group",
    componentName: "app-filter-group",
    mixins: [emitter],
    props: {
      reset: {
        type: Boolean,
        default: true
      },
      query: {
        type: Boolean,
        default: true
      },
      queryButtonType:{
        type:String,
        default:'primary'
      },
      queryLoading:{
        type: Boolean,
        default: false,
      },
      // 是否需要高级筛选
      advancedFiltering: {
        type: Boolean,
        default: false 
      },
      // 高级筛选选项
      screenOptons: {
        type: Array,
        default: () => []
      },
      isBr: { // 自动换行
        type: Boolean,
        default: true
      },
      fixWidth: { // 自动换行的边界值  200
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        showFloorFilter: false,
        showAdvancedFilterBtn: false,
        showAdvancedFilterGroup: false,
        visiblePopover: false, // 高级筛选弹窗
        filterItems: [],
        beyondWidth: 0,
        showSecondRow:false,  //  第二行插槽
        secondItems:[],
        extendSearch: [], // 确定的高级筛选数据
        expOptions: [
          {text: ">", id: 'gt'},
          {text: ">=", id: 'ge'},
          {text: "=", id: 'eq'},
          {text: "<", id: 'lt'},
          {text: "<=", id: 'le'},
        ]
      }
    },
    created() {
      this.$on('app.filterItem.addFilterItem', (filterItem) => {
        this.filterItems.push(filterItem);
      });
    },
    mounted() {
      if (this.isBr) {
        this.autoWrap();  // 自动换行
      }
      if (this.$slots['advancedFilter']) {
        this.showAdvancedFilterBtn = true;
      } else {
        const filterGroup = this.$refs['filterGroup'];  // 整个容器的DOM
        const filterItems = this.$refs['filterItems'].$el;  // 查询条件所占的 DOM
        const filterRight = this.$refs['filterRight'];   //  右边固定的 DOM
        this.beyondWidth = filterItems.offsetWidth + filterRight.offsetWidth - filterGroup.offsetWidth;
        this.mayReflow();
      }
    },
    methods: {
      // 重置
      refreshAdvanced(isShow){
        this.showAdvancedFilterGroup = isShow
      },
      resetFn() {
        this.extendSearchClearAll()
        this.$emit('reset')
      },
      autoWrap(){
        const allWidth = this.$refs['filterGroup'].offsetWidth;  // 整个容器的DOM
        let fixWidth = this.clientWidth < 1440 ? 280 : 350;  // 右边固定宽度 以分辨率判断
        if (this.fixWidth !== 0) fixWidth = this.fixWidth // 新增可自定义的换行宽度传入
        let calcWidth = allWidth - fixWidth;
        let defaultSlots = this.$slots['default'];
        let sumWidths = 0;
        let secondSlots = [];
        defaultSlots.forEach(item =>{
           sumWidths += item?.elm.offsetWidth ? item?.elm.offsetWidth : 0
          // 查询条件总宽度 大于 可视宽度的时
           if(sumWidths > calcWidth){
             secondSlots.push(item);
           }
        })
        // 把第二行的插槽数据插入 DOM节点中
       if(secondSlots.length > 0){
         this.showSecondRow = true;
         secondSlots.forEach(item => {
           const home = document.createComment('');
           const parentNode = item?.elm.parentNode;
           parentNode.replaceChild(home, item?.elm);
           this.$refs['secondGroup'].$el.appendChild(item?.elm);
         })
       }
        // 没有子元素时需要去除top边距
       if (this.$refs['secondGroup'].$el.children.length === 0) {
         this.$refs['secondGroup'].$el.style.marginTop = 0
       } else if(this.$refs['secondGroup'].$el?.children[0]?.style?.marginLeft) { 
         // 有边距则去除
         this.$refs['secondGroup'].$el.children[0].style.marginLeft = 0
       }
      },
      mayReflow() {
        if (this.beyondWidth > 0) {
          let beyondWidth = this.beyondWidth;
          // 按优先级从低到高排序 0 最大
          this.showAdvancedFilterBtn = true;
          beyondWidth += 77;
          this.filterItems.sort((e1, e2) => Number(e2.priority) - Number(e1.priority));
          let i = 0;
          for (; i < this.filterItems.length; i++) {
            const filterItem = this.filterItems[i];
            beyondWidth = beyondWidth - filterItem.$el.offsetWidth;
            const home = document.createComment('');
            const parentNode = filterItem.$el.parentNode;
            parentNode.replaceChild(home, filterItem.$el);
            this.$refs['filterAdvanceGroup'].$el.appendChild(filterItem.$el);
            if (beyondWidth < 0) {
              break;
            }
          }
        }
      },
      handleQuery () {
        this.$emit('query')
       },
       //  高级筛选取消
       cancel() {
         this.visiblePopover = false
       },
      //  高级筛选确认
      determine() {
        this.visiblePopover = false
        this.extendSearch = this.screenOptons
          .map(e => ({ value: e.value, exp: e.exp, name: e.text, field: e.id, suffix: e.suffix }))
          .filter(e => e.value)
        this.$emit("determine", this.extendSearch)
      },
      getExp(val) {
        let item = this.expOptions.find(e => e.id == val)
        return (item && item.text) || val
      },
      // 删除高级搜索
      extendSearchClear(index, item) {
        this.extendSearch.splice(index, 1)
        let cell = this.screenOptons.find(e => e.id == item.field)
        cell.value = ""
        cell.exp = "gt"
        this.$emit("clear", this.extendSearch)
      },
      extendSearchClearAll(clear) {
        this.extendSearch = []
        this.screenOptons.forEach(e => {
          e.value = ""
          e.exp = "gt"
        })
        clear && this.$emit("clear", this.extendSearch)
      }
      //  cacheDataFn() {
      //    this.$nextTick(() => {
      //     const currentRouteInstance = this.findParentComponentInstance(this.$parent)
      //     let CACHE_PARAMS = currentRouteInstance.CACHE_PARAMS || {}
      //     // 规定缓存在业务模块中具体需要缓存的查询字段
      //     if (currentRouteInstance.$gjCacheCallback && typeof currentRouteInstance.$gjCacheCallback === 'function') {
      //       CACHE_PARAMS = currentRouteInstance.$gjCacheCallback(CACHE_PARAMS)
      //     }

      //     if (currentRouteInstance.notStorage) return
      //     this.$cache.setCache(currentRouteInstance.filterStoragekey || currentRouteInstance.moduleName || currentRouteInstance.$options.name, CACHE_PARAMS)
      //   })
      //  },
      // /**
      //  * 向上查找存在CACHE_PARAMS的组件
      //  * @param instance
      //  * @returns {{component: *, instance: ({$options}|*)}|{}}
      //  */
      // findParentComponentInstance (instance) {
      //   if (!instance) return
      //   let CACHE_PARAMS = instance && instance.CACHE_PARAMS ? instance.CACHE_PARAMS : null
      //   if (CACHE_PARAMS) {
      //     return instance
      //   }
      //   instance = instance.$parent
      //   return this.findParentComponentInstance(instance)
      // }
      
      // /**
      //  * 向上查找存在CACHE_PARAMS的组件
      //  * @param instance
      //  * @returns {{component: *, instance: ({$options}|*)}|{}}
      //  */
      // findParentComponentInstance (instance) {
      //   if (!instance) return
      //   let CACHE_PARAMS = instance && instance.CACHE_PARAMS ? instance.CACHE_PARAMS : null
      //   if (CACHE_PARAMS) {
      //     return instance
      //   }
      //   instance = instance.$parent
      //   return this.findParentComponentInstance(instance)
      // }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.el-input__suffix {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chunk-input-item {
    position: relative;
    /deep/ .el-input__suffix-inner{
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 1px;
      right: -4px;
      height: 24px;
      width: 24px;
      background: #EEEFF0;
    }
  }
  .filter-group{
    width: 100%;
  }
  .icon-down {
    margin-left: 5px;
  }
  .filter-group__advanced {
    margin-top: 10px;
  }
  .right-button-group {
    display: flex;
  }
  /deep/ .operate-group {
    margin: 0 !important;
  }
  .advancedFiltering {
    width: 30px;
    height: 30px;
    border: 1px solid rgb(216, 218, 221);
    display: flex;
    border-radius: 2px;
    align-items: center;
    margin-left: 8px;
    justify-content: center;
    margin-right: 0px;
    cursor: pointer;
    &:hover {
      color: #c0c4cc;
    }
  }
  .advancedFiltering-conent {
    font-size: 12px;
    .advancedFiltering-cell {
      display: flex;
      align-items: center;
      padding-bottom: 8px;
      .item-input {
        flex: 1;
      }
      .text {
        width: 64px;
        text-align: right;
      }
      .chunk-input-item {
        /deep/.el-input-group__append {
          position: relative;
          z-index: 1;
          padding: 0 !important;
          line-height: 24px;
          height: 24px;
          z-index: 1;
          position: relative;
        }
        /deep/.el-input__inner {
          position: relative;
          &:hover {
            z-index: 2;
          }
          &:focus {
            z-index: 2;
          }
        }
      }
      /deep/.el-input__inner {
        height: 26px;
        line-height: 26px;
        box-shadow: none;
      }
      /deep/.el-select {
        margin:0 12px;
      }
    }
    .advancedFiltering-footer {
      display: flex;
      justify-content: flex-end;
      padding-top: 8px;
      /deep/.el-button--small {
        padding: 5px 12px;
      }
    }
    
  }
  .extend-search {
    padding-top: 8px;
    display: flex;
    flex-wrap: wrap;
    .extend-search-cell {
      position: relative;
      padding: 5px 12px;
      margin-right: 8px;
      margin-bottom: 4px;
      padding-right: 24px;
      line-height: 1;
      color: #333;
      background: #EDF7FF;
      border: 1px solid #9CCCFF;
      border-radius: 2px;
      font-size: 12px;
      .el-icon-close {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        padding: 0 6px;
        color: #999;
        cursor: pointer;
      }
    }
    .clear-all {
      line-height: 24px;
      font-size: 12px;
      color: #666666;
      cursor: pointer;
    }
  }

  .query-enter-active, .query-leave-active {
    transition: opacity .3s;
  }
  .query-enter, .query-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

</style>
